import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/functions';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
};

let firebase = app.initializeApp(config);

export let auth = firebase.auth();
export let storage = firebase.storage();
export const db = firebase.firestore();
export const functions = firebase.functions();
export let admin = app;
export const firebaseConfig = config;

// Instancia secundaria para el portal de clientes (no afecta al auth del admin)
const portalApp = app.apps.find(a => a.name === 'ClientPortal') ||
    app.initializeApp(config, 'ClientPortal');
export const portalAuth = portalApp.auth();